import axios from 'axios';

export const toetsRoles = ['super_admin', 'locatie_admin', 'docent'];
export const isToetsAdmin = role => ['super_admin', 'locatie_admin'].includes(role);
export function currentSchoolYear(now = new Date()) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Amsterdam', year: 'numeric', month: 'numeric'
  }).formatToParts(now).map(p => [p.type, p.value]));
  const year = Number(parts.year) - (Number(parts.month) < 8 ? 1 : 0);
  return `${year}-${year + 1}`;
}
export function schoolYears(extra = []) {
  const year = Number(currentSchoolYear().slice(0, 4));
  return [...new Set([...extra.filter(Boolean), ...Array.from({ length: 7 }, (_, i) => `${year + 1 - i}-${year + 2 - i}`)])].sort().reverse();
}
export const emptyPart = () => ({ title: '', correct_count: '', incorrect_count: '', percentage: '', grade: '' });
export function localDateToday(now = new Date()) {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
export const emptyResult = () => ({ title: '', student_id: '', template_id: '', school_year: currentSchoolYear(),
  test_date: localDateToday(), correct_count: '', incorrect_count: '', grade: '', parts: [] });
export const numberOrNull = value => value === '' || value === null || value === undefined ? null : Number(value);
export function hasScoreCounts(value) {
  return [value.correct_count, value.incorrect_count].every(v => {
    const count = numberOrNull(v);
    return count !== null && Number.isInteger(count) && count >= 0 && count <= 1000000;
  });
}
export function gradeFor(value) {
  if (!hasScoreCounts(value)) return value.grade ?? '';
  const correct = Number(value.correct_count), incorrect = Number(value.incorrect_count);
  return correct + incorrect > 0 ? Math.round(correct / (correct + incorrect) * 1000) / 100 : '';
}
export function percentageFor(part) {
  const correct = numberOrNull(part.correct_count), incorrect = numberOrNull(part.incorrect_count);
  if (correct !== null && incorrect !== null) {
    return correct + incorrect > 0 ? Math.round(correct / (correct + incorrect) * 10000) / 100 : '';
  }
  return part.percentage ?? '';
}
export function resultPayload(form) {
  const payload = { student_id: form.student_id, template_id: form.template_id || null,
    title: form.title.trim(), school_year: form.school_year || null, test_date: form.test_date || null,
    correct_count: numberOrNull(form.correct_count), incorrect_count: numberOrNull(form.incorrect_count),
    grade: numberOrNull(gradeFor(form)), parts: form.parts.map(p => ({ title: p.title.trim(),
      correct_count: numberOrNull(p.correct_count), incorrect_count: numberOrNull(p.incorrect_count),
      percentage: numberOrNull(percentageFor(p)), grade: numberOrNull(gradeFor(p)) })) };
  if (form.version) payload.version = form.version;
  return payload;
}
export function api(method, path = '', data, options = {}) {
  return axios({ method, url: `${process.env.REACT_APP_BACKEND_URL}/toetsen${path}`, data, ...options,
    headers: { Authorization: `Bearer ${sessionStorage.getItem('jwtToken')}` } });
}
export const errorMessage = error => error.response?.data?.message || 'De gegevens konden niet worden geladen of opgeslagen. Probeer het opnieuw.';
export const displayNumber = value => value === '' || value === null || value === undefined ? '—' : Number(value).toLocaleString('nl-NL', { maximumFractionDigits: 2 });
export const displayDate = value => value ? value.slice(0, 10).split('-').reverse().join('-') : '—';
